<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="container">
  <div class="heading-container">
    <p class="heading" i18n>{{ data.title }}</p>
    <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>
  </div>

  <div class="content">
    <ng-container *ngIf="data.genes;">
      <div class="pill-wrap" role="list" aria-label="Gene List">
        <div class="gene-list" *ngFor="let g of data.genes;">
          <a href="javascript:void(0)" (click)="openEnsembl(g.id)" class="pill">
            {{ g.name }}
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</div>